import { styled } from 'goober'

export const CopySuccessDiv = styled('div')`
  color: var(--success);
`

export const CopyRowWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.5em;
  padding-bottom: 0.5em;
`
